import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IDetailRoomsModalHotelDisplayData } from 'model/view-models/results/product-card/price-display-data.interface';

@Component({
  selector: 'usb-room-detail',
  templateUrl: './room-detail.component.html',
  styleUrls: ['../room.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoomDetailComponent implements OnInit {

  @Input() detailRoomData!: IDetailRoomsModalHotelDisplayData;
  @Input() currencies;
  @Input() currencyAgency;
  @Input() clientSetting;
  @Output() openPolitics = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  open(): void {
    this.openPolitics.emit();
  }

}
